import { render, staticRenderFns } from "./CasePlanAlimentaire.vue?vue&type=template&id=123208e3&scoped=true&"
import script from "./CasePlanAlimentaire.vue?vue&type=script&lang=js&"
export * from "./CasePlanAlimentaire.vue?vue&type=script&lang=js&"
import style0 from "./CasePlanAlimentaire.vue?vue&type=style&index=0&id=123208e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123208e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('123208e3')) {
      api.createRecord('123208e3', component.options)
    } else {
      api.reload('123208e3', component.options)
    }
    module.hot.accept("./CasePlanAlimentaire.vue?vue&type=template&id=123208e3&scoped=true&", function () {
      api.rerender('123208e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Menus/CasePlanAlimentaire.vue"
export default component.exports